module.exports = __webpack_public_path__ + "img/logo.21d1df4a.png";